import { HomeLockOpenIcon } from './HomeLockOpenIcon';

/**
 * author: Nick
 * id 0E63785D-BB37-4A60-B09D-F985DC4FAD5F
 * name home-lock-open
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lock-open.svg
 * tags
 * - Home Automation 
 * - Lock 
 */
export const HouseLockOpenIcon = HomeLockOpenIcon;
export default HouseLockOpenIcon